import React from 'react';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import AppRouter from './router/index';
import { AuthProvider } from 'contexts/AuthContext';
import { setNavigator } from 'lib/navigation';

const NavigationSetter: React.FC = () => {
  const navigate = useNavigate();
  React.useEffect(() => { setNavigator(navigate); }, [navigate]);
  return null;
}

const AppRoot: React.FC = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <NavigationSetter />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
};

export default AppRoot;
